/**
 * ═══════════════════════════════════════════════════════════════
 *  MRS. MAILBOX — Product Main JS
 *  assets/mm-product-main.js
 *
 *  KAPSAM:
 *  Bu dosya mm-product-main section'ına ait tüm JS'i barındırır.
 *  Her feature kendi init fonksiyonu ile ayrılmıştır.
 *
 *  MEVCUT MODÜLLER:
 *  1. mmGallery   — thumbnail ↔ main image switcher + counter
 *
 *  SONRAKI MODÜLLER (ileride buraya eklenir):
 *  - mmVariants   — variant selector logic
 *  - mmAccordion  — accordion open/close
 *  - mmQuantity   — quantity stepper
 *
 *  KULLANIM:
 *  Dawn → assets/mm-product-main.js olarak kaydet.
 *  section .liquid dosyasına:
 *    {{ 'mm-product-main.js' | asset_url | script_tag }}
 *  veya:
 *    <script src="{{ 'mm-product-main.js' | asset_url }}" defer></script>
 *
 *  DATA ATTRİBÜTLERİ:
 *  [data-mm-gallery]    → her gallery bileşeninin root'u
 *  [data-mm-main-image] → değiştirilecek <img>
 *  [data-mm-counter]    → "X / Y" text node'u tutan element
 *  [data-mm-thumb]      → tıklanabilir thumbnail <button>
 *    [data-mm-full-src] → yüklenecek tam görselin src'si
 *    [data-mm-alt]      → ana görsele yazılacak alt metni
 *    [data-mm-index]    → 1-tabanlı sıra numarası
 * ═══════════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     1. GALLERY MODULE
     ───────────────────────────────────────────────────────────── */

  function MMGallery(root) {
    // ── DOM refs ──────────────────────────────────────────────
    const mainImage = root.querySelector('[data-mm-main-image]');
    const counter   = root.querySelector('[data-mm-counter]');
    const thumbs    = Array.from(root.querySelectorAll('[data-mm-thumb]'));
    const btnPrev   = root.querySelector('[data-mm-gallery-prev]');
    const btnNext   = root.querySelector('[data-mm-gallery-next]');

    if (!mainImage || thumbs.length === 0) return;

    // ── State ─────────────────────────────────────────────────
    let activeIndex    = 1;
    const total        = thumbs.length;
    let fadeTimer      = null;
    let swapGeneration = 0;   // stale callback koruması için
    var preloadedUrls  = new Set(); // preload edilmiş URL'leri takip eder; aynı URL'i iki kez indirme
    // Hover preload yalnızca gerçek hover destekleyen (pointer: fine) cihazlarda bağlanır.
    // Touch cihazlarda pointerenter yalnızca dokunulan thumbnail için tekil ateşlenir,
    // bu yüzden "tüm galeri görsellerini indir" davranışı oluşmaz.
    var supportsHover  = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : false;

    // CSS transition ile tam senkronize (mm-product-main.css: 0.25s)
    const FADE_MS = 250;

    if (btnPrev) btnPrev.setAttribute('aria-disabled', 'true');
    if (btnNext) btnNext.setAttribute('aria-disabled', total <= 1 ? 'true' : 'false');

    // ── Thumbnail click ────────────────────────────────────────
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx     = parseInt(thumb.dataset.mmIndex, 10);
        const fullSrc = thumb.dataset.mmFullSrc;
        const alt     = thumb.dataset.mmAlt || '';
        if (idx === activeIndex) return;
        activateThumb(thumb, idx);
        swapMainImage(fullSrc, alt);
        updateCounter(idx);
        preloadAdjacent(idx);
      });

      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });

      // ── Hover / Focus preload ────────────────────────────────
      // Kullanıcı thumbnail ile ETKİLEŞİME GEÇMEDEN hemen önce ilgili büyük
      // görseli sessizce tarayıcı cache'ine alır. swapMainImage/decode/fade
      // akışına hiç dokunmaz; click anında src atandığında görsel çoğu zaman
      // zaten hazır olduğundan geçiş "takılmadan" hissettirir.
      // preloadedUrls Set'i preloadAdjacent ile paylaşıldığından çift indirme olmaz.
      if (supportsHover) {
        thumb.addEventListener('pointerenter', function () {
          preloadFullSrc(thumb.dataset.mmFullSrc);
        });
      }
      thumb.addEventListener('focus', function () {
        preloadFullSrc(thumb.dataset.mmFullSrc);
      });
    });

    // ── Prev / Next ───────────────────────────────────────────
    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(activeIndex + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(activeIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex + 1); }
    });

    // ── Mobile Swipe (touch-only, passive, scroll-safe) ───────
    (function () {
      if (total <= 1) return;
      if (!('ontouchstart' in window)) return;

      var mainArea = root.querySelector('.mm-product-gallery__main');
      if (!mainArea) return;

      var SWIPE_X_MIN = 50;
      var startX      = 0;
      var startY      = 0;
      var tracking    = false;

      mainArea.addEventListener('touchstart', function (e) {
        var t  = e.changedTouches[0];
        startX   = t.clientX;
        startY   = t.clientY;
        tracking = true;
      }, { passive: true });

      mainArea.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;

        var t      = e.changedTouches[0];
        var deltaX = t.clientX - startX;
        var deltaY = t.clientY - startY;

        if (Math.abs(deltaX) < SWIPE_X_MIN)            return;
        if (Math.abs(deltaY) > Math.abs(deltaX) * 0.8) return;

        if (deltaX < 0) { goTo(activeIndex + 1); }
        else            { goTo(activeIndex - 1); }
      }, { passive: true });

      mainArea.addEventListener('touchcancel', function () {
        tracking = false;
      }, { passive: true });
    }());

    // ── Thumbnail scroll nav (desktop/tablet) ─────────────────
    (function () {
      var nav     = root.querySelector('[data-mm-thumb-nav]');
      if (!nav) return;
      var track   = nav.querySelector('.mm-product-gallery__thumbs');
      var navPrev = nav.querySelector('[data-mm-thumb-prev]');
      var navNext = nav.querySelector('[data-mm-thumb-next]');
      if (!track || !navPrev || !navNext) return;

      var STEP = 180; // px — bir adımda scroll miktarı

      function updateNavBtns() {
        var overflows = track.scrollWidth > track.clientWidth + 1;
        if (!overflows) {
          navPrev.classList.remove('mm-thumb-nav__btn--visible');
          navNext.classList.remove('mm-thumb-nav__btn--visible');
          return;
        }
        var atStart = track.scrollLeft < 2;
        var atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        navPrev.classList.toggle('mm-thumb-nav__btn--visible', !atStart);
        navNext.classList.toggle('mm-thumb-nav__btn--visible', !atEnd);
      }

      navPrev.addEventListener('click', function () {
        track.scrollBy({ left: -STEP, behavior: 'smooth' });
      });

      navNext.addEventListener('click', function () {
        track.scrollBy({ left: STEP, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNavBtns, { passive: true });
      window.addEventListener('resize', updateNavBtns, { passive: true });

      updateNavBtns();
    }());

    // ── Functions ─────────────────────────────────────────────

    // ── preloadFullSrc — tek bir büyük görseli cache'e ısıt ─────────
    // preloadAdjacent ile AYNI preloadedUrls Set'ini kullanır: bir URL
    // hover/focus ile ısıtıldıysa adjacent onu tekrar indirmez (ve tersi).
    function preloadFullSrc(url) {
      if (!url || preloadedUrls.has(url)) return;
      preloadedUrls.add(url);
      var img = new Image();
      img.src = url; // hiçbir yere basılmaz; sadece tarayıcı cache'ini ısıtır
    }

    // ── preloadAdjacent — komşu görselleri arka planda cache'e al ────
    // swapMainImage() akışına hiç dokunmaz; sadece browser cache'ini ısıtır.
    // Kullanıcı o görsele geçtiğinde src ataması yapılır (zamanlama değişmez),
    // ama görsel zaten cache'de hazır olduğundan download süresi ~0ms olur.
    function preloadAdjacent(currentIdx) {
      [-1, 1].forEach(function (offset) {
        var neighborIdx = currentIdx + offset;
        if (neighborIdx < 1 || neighborIdx > total) return; // sınır dışı
        var url = thumbs[neighborIdx - 1].dataset.mmFullSrc;
        if (!url || preloadedUrls.has(url)) return;         // boş veya daha önce yüklenmiş
        preloadedUrls.add(url);
        var img  = new Image();
        img.src  = url; // browser bu URL'i cache'e alır; görsel hiçbir yerde gösterilmez
      });
    }

    function goTo(targetIdx) {
      const idx = Math.max(1, Math.min(total, targetIdx));
      if (idx === activeIndex) return;
      const thumb = thumbs[idx - 1];
      activateThumb(thumb, idx);
      swapMainImage(thumb.dataset.mmFullSrc, thumb.dataset.mmAlt || '');
      updateCounter(idx);
      preloadAdjacent(idx);
    }

    function activateThumb(activeThumb, idx) {
      thumbs.forEach(function (t) {
        const isActive = t === activeThumb;
        t.classList.toggle('mm-product-gallery__thumb--active', isActive);
        t.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      activeIndex = idx;

      // Aktif thumbnail'ı thumb row içinde ortala (sayfa scroll'unu tetikleme)
      var track = activeThumb.closest('.mm-product-gallery__thumbs');
      if (track) {
        var offset = activeThumb.offsetLeft - (track.clientWidth / 2) + (activeThumb.offsetWidth / 2);
        track.scrollTo({ left: offset, behavior: 'smooth' });
      }

      if (btnPrev) btnPrev.setAttribute('aria-disabled', idx <= 1    ? 'true' : 'false');
      if (btnNext) btnNext.setAttribute('aria-disabled', idx >= total ? 'true' : 'false');
    }

    function swapMainImage(src, alt) {
      if (fadeTimer) {
        clearTimeout(fadeTimer);
        fadeTimer = null;
      }

      // Her swap isteğine benzersiz bir nesil numarası atıyoruz.
      // Decode/load callback ateşlendiğinde, bu değer artık geçerli
      // nesille eşleşmiyorsa (= araya yeni bir swap girdiyse) fade-in
      // yapılmaz — böylece stale callback flash'i önleniyor.
      var gen = ++swapGeneration;

      // Zaten opacity:0 durumdaysak tekrar fade-out beklemeye gerek yok;
      // rapid click'lerde 250ms ek gecikme birikmesini önler.
      var isFading = mainImage.classList.contains('mm-gallery--fading');

      // <img> kaybolmadan önce eski görseli container background'una sabitle.
      // Böylece decode tamamlanana kadar beyaz boş frame yerine eski görsel görünür.
      // Sadece görsel zaten görünür durumdayken (isFading=false) pinliyoruz;
      // rapid click'lerde background zaten önceki click'ten sabitlenmiş olur.
      var container = mainImage.closest('.mm-product-gallery__main');
      if (container && mainImage.currentSrc && !isFading) {
        container.style.backgroundImage    = 'url("' + mainImage.currentSrc + '")';
        container.style.backgroundSize     = 'cover';
        container.style.backgroundPosition = 'center';
      }

      if (!isFading) mainImage.classList.add('mm-gallery--fading');

      fadeTimer = setTimeout(function () {
        fadeTimer     = null;
        mainImage.alt = alt;
        mainImage.src = src;

        // Yeni görsel ekrana basılmaya hazır olduğunda fade-in yap.
        // rAF×2 yerine decode() kullanarak "eski görsel geri gelme"
        // flash'ini önlüyoruz: görsel decode edilmeden opacity açılmıyor.
        function fadeIn() {
          if (gen !== swapGeneration) return; // stale → yok say
          requestAnimationFrame(function () {
            mainImage.classList.remove('mm-gallery--fading');
            // Yeni görsel görünür olduğunda pinlenen background'u temizle.
            if (container) {
              container.style.backgroundImage    = '';
              container.style.backgroundSize     = '';
              container.style.backgroundPosition = '';
            }
          });
        }

        if (typeof mainImage.decode === 'function') {
          // Modern path: decode() resolve = görsel paint'e hazır
          mainImage.decode().then(fadeIn).catch(fadeIn);
        } else {
          // Eski browser fallback: load event veya complete flag
          if (mainImage.complete) {
            fadeIn();
          } else {
            mainImage.addEventListener('load', fadeIn, { once: true });
            setTimeout(fadeIn, 2000); // 2s safety net — takılıp kalmasın
          }
        }
      }, isFading ? 0 : FADE_MS);
    }

    function updateCounter(idx) {
      if (!counter) return;
      counter.textContent = idx + ' / ' + (root.dataset.mmCount || thumbs.length);
    }
  }

  /* ─────────────────────────────────────────────────────────────
     2. QUANTITY STEPPER MODULE
     ───────────────────────────────────────────────────────────── */

  function initQuantitySteppers(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mm-qty-plus], [data-mm-qty-minus]').forEach(function (btn) {
      if (btn.dataset.mmQtyBound) return;
      btn.dataset.mmQtyBound = '1';
      btn.addEventListener('click', function () {
        var wrap  = btn.closest('.mm-product-info__quantity');
        if (!wrap) return;
        var input = wrap.querySelector('[data-mm-qty-input]');
        if (!input) return;
        var current = parseInt(input.value, 10) || 1;
        var min     = parseInt(input.min, 10)   || 1;
        var max     = parseInt(input.max, 10)   || 99;
        var isPlus  = btn.hasAttribute('data-mm-qty-plus');
        input.value = isPlus ? Math.min(current + 1, max) : Math.max(current - 1, min);
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────
     3. INIT
     ───────────────────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('[data-mm-gallery]').forEach(function (root) {
      MMGallery(root);
    });
    initQuantitySteppers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ─────────────────────────────────────────────────────────────
     4. SHOPIFY SECTION EVENTS
     ───────────────────────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    section.querySelectorAll('[data-mm-gallery]').forEach(function (root) {
      MMGallery(root);
    });
    initQuantitySteppers(section);
  });

}());